var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_551)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 324",
    x: 27.5,
    y: 24.75,
    width: 15.125,
    height: 27.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.92255 53.9974C3.95764 55.6641 5.16029 57.75 7.08612 57.75H58.9139C60.8397 57.75 62.0424 55.6641 61.0774 53.9974L35.1636 9.23706C34.2007 7.57385 31.7993 7.57386 30.8364 9.23707L4.92255 53.9974ZM35.75 47C35.75 48.3807 34.6307 49.5 33.25 49.5H32.75C31.3693 49.5 30.25 48.3807 30.25 47V46.5C30.25 45.1193 31.3693 44 32.75 44H33.25C34.6307 44 35.75 45.1193 35.75 46.5V47ZM35.75 36C35.75 37.3807 34.6307 38.5 33.25 38.5H32.75C31.3693 38.5 30.25 37.3807 30.25 36V30C30.25 28.6193 31.3693 27.5 32.75 27.5H33.25C34.6307 27.5 35.75 28.6193 35.75 30V36Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 8.75,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.29e87dcfcc5f1d02954e59c7359abcb3.svg";
export { ForwardRef as ReactComponent };